// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"120":"5608e33f","453":"10f0caca","671":"1e374017"}[chunkId] + ".chunk.js");